var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-end mb-4 position-relative" },
    [
      _c(
        "b-col",
        { attrs: { cols: "3" } },
        [
          _vm.fee.default
            ? _c("h6", { staticClass: "form-title font-sm" }, [
                _vm._v("\n      " + _vm._s(_vm.fee.type) + "\n    "),
              ])
            : _c("select-section", {
                attrs: {
                  placeholder: _vm.$t(
                    "direct-to-lender.commissions.fees.feeType"
                  ),
                  options: _vm.feeTypeOptions,
                  disabled: _vm.isReadOnly,
                },
                model: {
                  value: _vm.computedFeeType,
                  callback: function ($$v) {
                    _vm.computedFeeType = $$v
                  },
                  expression: "computedFeeType",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "1" } },
        [
          _vm.showBasisPoints
            ? _c(
                "material-input",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: {
                        title: _vm.$t(
                          "direct-to-lender.commissions.fees.selectFeeType"
                        ),
                        disabled: _vm.fee.type,
                      },
                      expression:
                        "{\n        title: $t('direct-to-lender.commissions.fees.selectFeeType'),\n        disabled: fee.type\n      }",
                    },
                  ],
                  staticClass: "form-group-material-no-label",
                  attrs: {
                    placeholder: _vm.$t(
                      "direct-to-lender.commissions.fees.bps"
                    ),
                    "hidden-label": "",
                    label: _vm.$t("direct-to-lender.commissions.fees.bps"),
                    "label-for": "bps-input",
                  },
                },
                [
                  _vm.showBasisPoints
                    ? _c("decimal-input", {
                        attrs: {
                          id: "bps-input-" + _vm.id,
                          disabled: !_vm.fee.type || _vm.isReadOnly,
                          value: _vm.computedBasisPoints,
                          placeholder: _vm.$t(
                            "direct-to-lender.commissions.fees.bps"
                          ),
                          name: "basis-points-input",
                          "max-length": 3,
                          decimals: 2,
                        },
                        on: { change: _vm.handleChangeBasisPoints },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "d-none", attrs: { for: "bps-input-" + _vm.id } },
            [_vm._v(_vm._s(_vm.$t("direct-to-lender.commissions.fees.bps")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "2" } }, [
        _c(
          "div",
          { staticClass: "dollar-prepend position-relative" },
          [
            _c("text-section", {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: {
                    title: _vm.$t(
                      "direct-to-lender.commissions.fees.selectFeeType"
                    ),
                    disabled: _vm.fee.type,
                  },
                  expression:
                    "{\n          title: $t('direct-to-lender.commissions.fees.selectFeeType'),\n          disabled: fee.type\n        }",
                },
              ],
              attrs: {
                "hidden-label": "",
                label: _vm.$t("global.words.amount"),
                disabled:
                  _vm.feeHasBasisPoints || !_vm.fee.type || _vm.isReadOnly,
                placeholder: _vm.$t("direct-to-lender.commissions.fees.amount"),
                "allow-minus": "",
                "class-name": "fe-num-field dollar",
              },
              model: {
                value: _vm.computedAmount,
                callback: function ($$v) {
                  _vm.computedAmount = $$v
                },
                expression: "computedAmount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "field",
            [
              _c("date-section", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      title: _vm.$t(
                        "direct-to-lender.commissions.fees.selectFeeType"
                      ),
                      disabled: _vm.fee.type,
                    },
                    expression:
                      "{\n          title: $t('direct-to-lender.commissions.fees.selectFeeType'),\n          disabled: fee.type\n        }",
                  },
                ],
                staticStyle: { "margin-bottom": "0px" },
                attrs: {
                  id: "fundsReceivedDatepicker-" + _vm.id,
                  disabled: !_vm.fee.type || _vm.isReadOnly,
                  placeholder: "YYYY-MM-DD",
                  "class-name": "date-format past-date",
                  "max-date": _vm.fundsReceivedEndDate,
                },
                model: {
                  value: _vm.computedFundsReceived,
                  callback: function ($$v) {
                    _vm.computedFundsReceived = $$v
                  },
                  expression: "computedFundsReceived",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.expandedGrid
        ? _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _vm.computedFeeType === "other"
                ? _c("text-section", {
                    attrs: {
                      placeholder: _vm.$t(
                        "direct-to-lender.commissions.fees.feeName"
                      ),
                      disabled: _vm.isReadOnly,
                      label: _vm.$t(
                        "direct-to-lender.commissions.fees.feeName"
                      ),
                    },
                    model: {
                      value: _vm.computedDescription,
                      callback: function ($$v) {
                        _vm.computedDescription = $$v
                      },
                      expression: "computedDescription",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fee.default && !_vm.isReadOnly
        ? _c(
            "span",
            { staticClass: "request-trash" },
            [
              _c("inline-prompt", {
                attrs: { "action-type": "delete" },
                on: { accept: _vm.handleRemove },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.saving
        ? _c(
            "span",
            [
              _c("inline-loader", {
                staticClass: "mx-2",
                attrs: { width: "16px", height: "16px" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }